import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";

const SidebarLayout = () => {
  return (
    <div className="w-screen h-screen bg-[#ECECEE] p-2 flex overflow-hidden">
      <div className="w-[16rem] h-[98vh] bg-white rounded-lg">
        <Sidebar />
      </div>
      <div className="ml-2 w-full h-[98vh]">
        <Outlet />
      </div>
    </div>
  );
};

export default SidebarLayout;
